import React, {FC} from 'react';

import {MediaSettingProps} from '../types';

export const SampleComponent: FC<MediaSettingProps> = () => {
  return <div>SampleComponent</div>;
};
